import React, { useState } from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  TextField,
  ButtonGroup,
  makeStyles,
} from "@material-ui/core";
import t from "../common/localization";
import { useSelector } from "react-redux";
import moment from "moment";
import { useEffectAsync } from "./../reactHelper";
import Autocomplete from "@material-ui/lab/Autocomplete";
import SelectField from "./../form/SelectField";
import EmailIcon from "@material-ui/icons/Email";
// import DownloadForOfflineIcon from "@material-ui/icons/DownloadForOffline";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { filterErrorMessage } from "../common/stringUtils";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    // display: "flexEnd",
    flexDirection: "row",
    textAlign: "right",
    display: "flex",
  },
  buttonWithSpace: {
    margin: theme.spacing(0.3),
  },
  content: {
    flex: 1,
    overflow: "auto",
    padding: theme.spacing(2),
  },
  form: {
    padding: theme.spacing(1, 2, 2),
  },
  button: {
    //  background: '#623DE6',
    border: 0,
    borderRadius: 15,
    boxShadow: "0 3px 5px 2px rgba(33, 203, 243, .3)",
    color: "white",
    height: 35,
    margin: 3,
    marginTop: -1,
    // padding: '0 20px',
    width: 80,
    flexDirection: "row",
    primaryTextColor: "white",
  },
  button1: {
    //  background: '#623DE6',
    border: 0,
    borderRadius: 15,
    boxShadow: "0 3px 5px 2px rgba(33, 203, 243, .3)",
    color: "white",
    height: 35,
    margin: 3,
    marginTop: -1,
    // padding: '0 20px',
    width: 120,
    flexDirection: "row",
    primaryTextColor: "white",
  },
  selectField: {
    textAlign: "left",
    color: "white",
    height: "50px",
    variant: "outlined",
    margin: "5px",
    width: "20%",
  },
  selectField1: {
    textAlign: "left",
    color: "white",
    height: "50px",
    variant: "outlined",
    margin: "5px",
    width: "30%",
  },
  overrides: {
    MuiTableRow: {
      hover: {
        backgroundColor: "RGBA(54,29,219,0.36)",
      },
    },
  },
  rootG: {
    "& > *": {
      margin: theme.spacing(1),
    },
    border: 0,
  },
  multipleAutoComplete: {
    // Hover
    '&[data-focus="true"]': {
      backgroundColor: "#b3aeae",
      borderColor: "transparent",
      color: "black",
    },
    // Selected
    '&[aria-selected="true"]': {
      backgroundColor: "#361DDB",
      borderColor: "transparent",
      color: "white",
    },
  },
  menuItemCss: {
    "&.Mui-selected": {
      background: "#361DDB",
      color: "white",
    },
    "&:hover": {
      background: "#b3aeae",
      color: "black",
    },
    "&:hover.Mui-selected": {
      background: "#361DDB",
      color: "white",
    },
  },
}));
const ReportFilter = ({ children, handleSubmit, showOnly, reportHeader }) => {
  const devices = useSelector((state) => Object.values(state.devices.items));
  const deviceData = useSelector((state) => state.devices.items);
  const [deviceId, setDeviceId] = useState([]);
  const [groupId, setGroupId] = useState([]);
  const [period, setPeriod] = useState("today");
  const [from, setFrom] = useState(moment().subtract(1, "hour"));
  const [to, setTo] = useState(moment());
  const [groupData, setGroupData] = useState([]);
  const classes = useStyles();
  const selectedId = useSelector((state) => {
    if (state.devices.selectedId) {
      // setDeviceId(state.devices.selectedId);
      return state.devices.selectedId;
    }
    return null;
  });

  const [openAlert, setOpenAlert] = React.useState({
    open: false,
    message: "",
    type: "error",
  });

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenAlert({
      open: false,
      message: "",
      type: "",
    });
  };

  const onResponseGet = async (response) => {
    if (response.ok) {
      const contentType = response.headers.get("content-type");
      if (
        contentType === "application/pdf" ||
        contentType ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        setOpenAlert({
          open: true,
          message: "Downloading Starting...",
          type: "success",
        });
      } else if (response.status === 204) {
        setOpenAlert({
          open: true,
          message: "Email sent successfully.",
          type: "success",
        });
      }
    } else {
      const errorMessage = response && (await response.text());
      setOpenAlert({
        open: true,
        message: filterErrorMessage(errorMessage),
        type: "error",
      });
    }
  };

  const handleClick = (mail, json, pdf = false) => {
    let selectedFrom;
    let selectedTo;
    switch (period) {
      case "today":
        selectedFrom = moment().startOf("day");
        selectedTo = moment().endOf("day");
        break;
      case "yesterday":
        selectedFrom = moment().subtract(1, "day").startOf("day");
        selectedTo = moment().subtract(1, "day").endOf("day");
        break;
      case "thisWeek":
        selectedFrom = moment().startOf("week");
        selectedTo = moment().endOf("week");
        break;
      case "previousWeek":
        selectedFrom = moment().subtract(1, "week").startOf("week");
        selectedTo = moment().subtract(1, "week").endOf("week");
        break;
      case "thisMonth":
        selectedFrom = moment().startOf("month");
        selectedTo = moment().endOf("month");
        break;
      case "previousMonth":
        selectedFrom = moment().subtract(1, "month").startOf("month");
        selectedTo = moment().subtract(1, "month").endOf("month");
        break;
      default:
        selectedFrom = from;
        selectedTo = to;
        break;
    }

    let accept = json
      ? "application/json"
      : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

    if (pdf) {
      accept = "application/pdf";
    }

    handleSubmit(
      reportHeader === "Point Transaction Report" || reportHeader === "Billing Transaction Report" || reportHeader === "Account Transaction Report" ? 0 : deviceId,
      reportHeader === "Point Transaction Report" || reportHeader === "Billing Transaction Report" || reportHeader === "Account Transaction Report" ? 0 : groupId,
      selectedFrom.toISOString(),
      selectedTo.toISOString(),
      mail,
      { Accept: accept },
      onResponseGet
    );
  };

  useEffectAsync(async () => {
    // setDeviceId(selectedId);
    const response = await fetch(`/api/groups`);
    const groups = await response.json();
    setGroupData(groups);
  }, []);

  return (
    <div className={classes.root}>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={openAlert.open}
        autoHideDuration={2000}
        onClose={handleClose}
      >
        <Alert onClose={handleClose} severity={openAlert.type}>
          {openAlert.message}
        </Alert>
      </Snackbar>
      <h4 style={{ margin: "10px", display: "flex" }}>
        {reportHeader || "Report"}
      </h4>

      {reportHeader !== "Point Transaction Report" && reportHeader !== "Billing Transaction Report" && reportHeader !== "Account Transaction Report" && (
      <FormControl
        className={classes.selectField}
        disabled={!deviceId && groupId}
      >
        {/* <InputLabel shrink>{t('reportDevice')}</InputLabel> */}
        <Autocomplete
          id="tags-outlinedhhh"
          options={devices}
          getOptionLabel={(option) => option.name}
          classes={{
            option: classes.multipleAutoComplete,
          }}
          // value={devices[0] || ""}
          // filterSelectedOptions
          // color={!deviceId.length && groupId.length ? 'red' : 'primary'}
          onChange={(e, value) => {
            const ids = value.map((item) => item.id);
            setDeviceId(ids);
          }}
          disabled={!deviceId.length && groupId.length}
          renderInput={(params) => (
            <TextField
              {...params}
              InputProps={{ ...params.InputProps, disableUnderline: true }}
              placeholder={
                deviceId.length
                  ? `${deviceData[deviceId[0]]?.name} ${
                      deviceId.length > 1 ? "+ " + (deviceId.length - 1) : ""
                    }`
                  : "Select Device"
              }
              variant="standard"
            />
          )}
          multiple
          renderTags={() => ``}
          disableCloseOnSelect
        />
      </FormControl>
      )}
      {(reportHeader !== "Route Report" && reportHeader !== "Point Transaction Report" && reportHeader !== "Billing Transaction Report" && reportHeader !== "Account Transaction Report") && (
        <FormControl
          className={classes.selectField}
          disabled={deviceId && !groupId}
        >
          <Autocomplete
            id="tags-group-mk"
            options={groupData}
            getOptionLabel={(option) => option.name}
            //color={deviceId.length && !groupId.length ? 'red' : 'primary'}
            onChange={(e, value) => {
              const ids = value.map((item) => item.id);
              setGroupId(ids);
            }}
            disabled={deviceId.length && !groupId.length}
            classes={{
              option: classes.multipleAutoComplete,
            }}
            // label={t("groupParent")}
            renderInput={(params) => {
              return (
                <TextField
                  {...params}
                  InputProps={{ ...params.InputProps, disableUnderline: true }}
                  placeholder="Select Group"
                  variant="standard"
                />
              );
            }}
            multiple
            renderTags={() => ``}
            disableCloseOnSelect
          />
        </FormControl>
      )}
      <FormControl className={classes.selectField}>
        {/* <InputLabel>{t('reportPeriod')}</InputLabel> */}
        <Select
          inputProps={{ "aria-label": "Without label" }}
          disableUnderline={true}
          value={period}
          onChange={(e) => setPeriod(e.target.value)}
        >
          <MenuItem className={classes.menuItemCss} value="today">
            {t("reportToday")}
          </MenuItem>
          <MenuItem className={classes.menuItemCss} value="yesterday">
            {t("reportYesterday")}
          </MenuItem>
          <MenuItem className={classes.menuItemCss} value="thisWeek">
            {t("reportThisWeek")}
          </MenuItem>
          <MenuItem className={classes.menuItemCss} value="previousWeek">
            {t("reportPreviousWeek")}
          </MenuItem>
          <MenuItem className={classes.menuItemCss} value="thisMonth">
            {t("reportThisMonth")}
          </MenuItem>
          <MenuItem className={classes.menuItemCss} value="previousMonth">
            {t("reportPreviousMonth")}
          </MenuItem>
          <MenuItem className={classes.menuItemCss} value="custom">
            {t("reportCustom")}
          </MenuItem>
        </Select>
      </FormControl>
      {period === "custom" && (
        <TextField
          className={classes.selectField}
          InputProps={{ "aria-label": "Without label", disableUnderline: true }}
          type="datetime-local"
          value={from.format(moment.HTML5_FMT.DATETIME_LOCAL)}
          onChange={(e) =>
            setFrom(moment(e.target.value, moment.HTML5_FMT.DATETIME_LOCAL))
          }
          fullWidth
        />
      )}
      {period === "custom" && (
        <TextField
          className={classes.selectField}
          InputProps={{ "aria-label": "Without label", disableUnderline: true }}
          type="datetime-local"
          value={to.format(moment.HTML5_FMT.DATETIME_LOCAL)}
          onChange={(e) =>
            setTo(moment(e.target.value, moment.HTML5_FMT.DATETIME_LOCAL))
          }
          fullWidth
        />
      )}
      {children}
      <FormControl
        className={classes.selectField1}
        disabled={!deviceId && !groupId}
      >
        {/* <Stack direction="row" spacing={2}> */}

        {/* </Stack> */}
        <div className={classes.root}>
          <Button
            variant="outlined"
            className={classes.buttonWithSpace}
            color={reportHeader !== "Point Transaction Report" && reportHeader !== "Billing Transaction Report" && reportHeader !== "Account Transaction Report" && (!deviceId.length && !groupId.length) ? "default" : "primary"}
            onClick={() => handleClick(false, true)}
            disabled={
              reportHeader !== "Point Transaction Report" && reportHeader !== "Billing Transaction Report" && reportHeader !== "Account Transaction Report" && (!deviceId.length && !groupId.length)
            }
          >
            {t("reportShow")}
          </Button>

          {!showOnly && (
            <>
              <Button
                variant="outlined"
                className={classes.buttonWithSpace}
                startIcon={<CloudDownloadIcon />}
                color={reportHeader !== "Point Transaction Report" && reportHeader !== "Billing Transaction Report" && reportHeader !== "Account Transaction Report" && (!deviceId.length && !groupId.length) ? "" : "primary"}
                onClick={() => handleClick(false, false, true)}
                disabled={reportHeader !== "Point Transaction Report" && reportHeader !== "Billing Transaction Report" && reportHeader !== "Account Transaction Report" && (!deviceId.length && !groupId.length)}
              >
                PDF
              </Button>
              <Button
                variant="outlined"
                className={classes.buttonWithSpace}
                startIcon={<CloudDownloadIcon />}
                color={reportHeader !== "Point Transaction Report" && reportHeader !== "Billing Transaction Report" && reportHeader !== "Account Transaction Report" && (!deviceId.length && !groupId.length) ? "" : "primary"}
                onClick={() => handleClick(false, false)}
                disabled={reportHeader !== "Point Transaction Report" && reportHeader !== "Billing Transaction Report" && reportHeader !== "Account Transaction Report" && (!deviceId.length && !groupId.length)}
              >
                XLS
              </Button>
              <Button
                variant="outlined"
                className={classes.buttonWithSpace}
                endIcon={<EmailIcon />}
                color={reportHeader !== "Point Transaction Report" && reportHeader !== "Billing Transaction Report" && reportHeader !== "Account Transaction Report" && (!deviceId.length && !groupId.length) ? "" : "primary"}
                onClick={() => handleClick(true, false, true)}
                disabled={reportHeader !== "Point Transaction Report" && reportHeader !== "Billing Transaction Report" && reportHeader !== "Account Transaction Report" && (!deviceId.length && !groupId.length)}
              >
                PDF
              </Button>
              <Button
                variant="outlined"
                className={classes.buttonWithSpace}
                endIcon={<EmailIcon />}
                color={reportHeader !== "Point Transaction Report" && reportHeader !== "Billing Transaction Report" && reportHeader !== "Account Transaction Report" && (!deviceId.length && !groupId.length) ? "" : "primary"}
                onClick={() => handleClick(true, false)}
                disabled={reportHeader !== "Point Transaction Report" && reportHeader !== "Billing Transaction Report" && reportHeader !== "Account Transaction Report" && (!deviceId.length && !groupId.length)}
              >
                XLS
              </Button>
            </>
          )}
        </div>
      </FormControl>
    </div>
  );
};

export default ReportFilter;
